// @ts-ignore
import { smallBottomBound, smallUpperBound, mediumBottomBound, mediumUpperBound, largeBottomBound, largeUpperBound, extraBottomBound, extraUpperBound } from "!!sass-variable-loader!assets/wows/stylesheets/core/_settings.media-queries.scss";

const parseCSSSize = (size: any) => {
  if (!size || !size.match(/^\d+px$/)) {
    throw 'can only work with strings containing values in px';
  }
  return parseInt(size, 10);
};

export default {
  smallBottomBound: parseCSSSize(smallBottomBound),
  smallUpperBound: parseCSSSize(smallUpperBound),

  mediumBottomBound: parseCSSSize(mediumBottomBound),
  mediumUpperBound: parseCSSSize(mediumUpperBound),

  largeBottomBound: parseCSSSize(largeBottomBound),
  largeUpperBound: parseCSSSize(largeUpperBound),

  extraBottomBound: parseCSSSize(extraBottomBound),
  extraUpperBound: parseCSSSize(extraUpperBound)
};